import type { ReviewSummaryRow } from '@/types/gtm-agents';

export function ReviewSummary({
  rows,
  label,
}: {
  rows: readonly ReviewSummaryRow[];
  label: string;
}) {
  return (
    <ul aria-label={label} className='space-y-[4px] text-[12px] leading-[16px]'>
      {rows.slice(0, 4).map((row, index) => (
        <li
          key={index}
          className='flex flex-wrap justify-between gap-x-[12px] gap-y-[2px]'
        >
          <span className='text-muted-foreground'>{row.label}</span>
          <span className='text-foreground'>{row.state}</span>
        </li>
      ))}
    </ul>
  );
}
